import DataTable from "@/components/common/DataTable";
import Pagination from "@/components/common/Pagination";
import PaginationWeb from "@/components/common/PaginationWxb";
const index = {
    data() {
        return {
            tableData: [],
            selectData: [],
            pageWxb: {
                //分页数据
                pageNum: 1, //当前页
                pageSize: 10, //分页大小
                total: 0, //总数据量
                changed: false
            },
            pageMs: {
                //分页数据
                pageNum: 1, //当前页
                pageSize: 10, //分页大小
                total: 0, //总数据量
                changed: false
            },
            pageFk: {
                //分页数据
                pageNum: 1, //当前页
                pageSize: 10, //分页大小
                total: 0, //总数据量
                changed: false
            },
            page: {
                //分页数据
                pageNum: 1, //当前页
                pageSize: 10, //分页大小
                total: 0, //总数据量
                changed: false
            }
        }
    },
    methods: {
        queryResult(data) {
            this.page.changed = false;
            if (data) {
                this.tableData = data.records;
                this.page.total = data.total;
            }
        },
        selects(data) {
            this.selectData = data;
        },
        operationFinish(msg) {
            this.page.changed = true
        }
    },
    components: { DataTable, Pagination, PaginationWeb},
    beforeCreate() {
        this.$options.__proto__.name = this.$route.name
    },
}
export default index
